import React from 'react';
import { ThemeProvider } from 'styled-components';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Accueil from './page/Accueil.js'
import PageLogin from './page/PageLogin.js';
import PageElement from './page/PageElement.js'
import PageElementsSearch from './page/PageElementsSearch.js';
import PageDerniersElements from './page/PageDerniersElements.js';
//import NoticesNuxeo from './page/NoticesNuxeo.js'
//import NoticesZotero from './page/NoticesZotero.js';
import PageEdit from './page/PageEdit.js';
import PageAdd from './page/PageAdd.js';
import PageDel from './page/PageDel.js';
import PageConsultation from './page/PageConsultation.js';
import PageAssociation from './page/PageAssociation.js';
import PageNotFound from './page/PageNotFound.js';

const  App = () => {

  return (
    <div className="App">


      <ThemeProvider
      theme={{
        colors: {
          orange: '#D9863D',
          black: '#2D2D2D',
          brown:'#99877E',
          beige:'#E0CEBE',
          lighterbeige:'#F8E6D7',
          lightrow:'#FFF',
          darkrow:'##D6EAF8'

          },
          }}>
            <BrowserRouter>
                <Routes>
                    <Route exact path="/" element={<Accueil/>}/>
                    <Route exact path="/login" element={<PageLogin/>}/>
                    <Route exact path="/:typeElement" element={<PageConsultation/>}/>
                    <Route exact path="/search/:typeElement/:nb/:index" element={<PageElementsSearch/>}/>
                    <Route exact path="/:typeElement/last/:limit" element={<PageDerniersElements/>}/>
                    <Route exact path="/:typeElement/edit/:id" element={<PageEdit/>}/>
                    <Route exact path="/:typeElement/del/:id" element={<PageDel/>}/>
                    <Route exact path="/:typeElement/add" element={<PageAdd/>}/>
                    <Route exact path="/:typeElement/:id" element={<PageElement/>}/>
                    <Route exact path="/association/:typeElement/:id/:typeElementAAssocier" element={<PageAssociation/>}/>
                    <Route path="*" element={<PageNotFound/>} />
                </Routes>
            </BrowserRouter>
    </ThemeProvider>
    </div>

  )
}

export default App;
